<template>
    <v-select
        @input="onChangeHandler"
        :options="countriesList"
        :value="value.length > 0 ? value : null"
        :placeholder="placeholder"
        :multiple="multiple"
        :reduce="multiple ? option => option : option => option.code"
        :clearable="clearable"
        :disabled="disabled"
        label="name"
    >
        <template slot="option" slot-scope="option">
            <div class="d-flex py-1">
                <p class="mb-0">{{ option.name }}</p>
                <p class="mb-0 ml-2 text-capitalize px-2 rounded-pill bg-info shadow">
                    {{ option.code }}
                </p>
            </div>
        </template>
    </v-select>
</template>

<script>
import datalist from '../../../frontend/src/mixins/datalist'

export default {
    mixins: [datalist],

    props: {
        placeholder: {
            type: String,
            default: 'Select country'
        },

        value: {
            default: null
        },

        multiple: {
            type: Boolean,
            default: true
        },

        clearable: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onChangeHandler(value) {
            this.$emit('select', value)
        }
    }
}
</script>

<style lang="scss">
.vs__dropdown-menu {
    z-index: 2000;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
    background-color: transparent;
}
</style>
